// extracted by mini-css-extract-plugin
export default {"playerBox":"Player_playerBox__W+p7A"};